import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=31c7f215&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=ts"
export * from "./AgentList.vue?vue&type=script&lang=ts"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=31c7f215&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7f215",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c7f215')) {
      api.createRecord('31c7f215', component.options)
    } else {
      api.reload('31c7f215', component.options)
    }
    module.hot.accept("./AgentList.vue?vue&type=template&id=31c7f215&scoped=true", function () {
      api.rerender('31c7f215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/AgentList.vue"
export default component.exports